/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import IconButton from "../IconButton";
import { validate } from "../../../helpers/gesture";
import styles from "./index.css";
import { tabIndex } from "../../../helpers/accessibility";

const cx = classnames.bind(styles);
const ESCAPE_KEY = 27;
const ENTER_KEY = 13;
const keyCode = e => e.keyCode || e.which;

class Dropdown extends Component {
  onClick = e => validate(e, this.props.open);
  onMouseEnter = e => validate(e, this.props.open);
  onMouseLeave = e => validate(e, this.props.onCloseWithMouse);
  closeWithMouse = e => {
    e.stopPropagation();
    validate(e, this.props.onCloseWithMouse);
  };
  handleKeyDown = e => {
    if (keyCode(e) === ESCAPE_KEY) {
      this.props.onCloseWithKeyboard(e);
    }
  };
  handleEnterKeyDown = e => {
    if (keyCode(e) === ENTER_KEY) {
      this.props.onCloseWithKeyboard(e);
    }
  };
  handleTransitionEnd = () => {
    const { isOpen, openComplete } = this.props;
    if (isOpen) {
      openComplete();
    }
  };

  render() {
    const { name, children, isOpen, isHidden, header, body } = this.props;

    const wrapperClassnames = cx(styles.wrapper, {
      [styles.wrapper__open]: isOpen,
      [styles.wrapper__hidden]: isHidden
    });

    return (
      <div
        id={`${name}Dropdown`}
        className={wrapperClassnames}
        onClick={this.onClick}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onKeyDown={this.handleKeyDown}
        role="presentation"
      >
        {children}
        <div
          className={styles.outerWrapper}
          data-testid={`${name.toLowerCase()}-dropdown`}
        >
          <div className={styles.innerWrapper}>
            <div
              className={styles.slidedown}
              onTransitionEnd={this.handleTransitionEnd}
            >
              <div className={styles.header}>
                {header && React.cloneElement(header, { focusable: isOpen })}
                <IconButton
                  icon="close"
                  onClick={this.closeWithMouse}
                  onKeyDown={this.handleEnterKeyDown}
                  className={styles.close}
                  tabIndex={tabIndex(isOpen)}
                  data-testid="account-close-btn"
                />
              </div>
              <div className={styles.body}>
                {body &&
                  React.cloneElement(body, {
                    focusable: isOpen,
                    queryParams: { nlid: "nav header" }
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Dropdown.propTypes = {
  name: PropTypes.string.isRequired,
  isOpen: PropTypes.bool,
  isHidden: PropTypes.bool,
  open: PropTypes.func,
  openComplete: PropTypes.func,
  onCloseWithMouse: PropTypes.func,
  onCloseWithKeyboard: PropTypes.func,
  children: PropTypes.node,
  header: PropTypes.node,
  body: PropTypes.node
};

export default Dropdown;



// WEBPACK FOOTER //
// ./template/components/Dropdown/Dropdown.js